module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/flat-eef5f51ad8f89be7ccd54a8886df50ef.png";